import styled from 'styled-components'

export const FacilityBookNowContainer = styled.div`
  width: 100%;
  height:100%;
  padding: 50px;
`
export const FormContent = styled.div`
  margin-top: 100px;
  -webkit-box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.2);
  -moz-box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.2);
  box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.2);
  border-radius: 8px;
  background: linear-gradient(to left, #00e3d6 50%,  ${({ theme }) => theme.colors.white} 50%);
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`
export const ColumnContent = styled.div`
  display:inline-block;
  width:50%;
`
export const ColumnImgContent = styled.div`
  display:inline-flex;
  justify-content: center;
  width:50%;
`
export const ReservationTitle = styled.h1`
  color: #1a1a1a;
  font-weight: 500;
  font-size: 28px;
  margin-top: 35px;
  margin-left: 20px;
`
export const BookInfoContent = styled.div`
  -webkit-box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.2);
  -moz-box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.2);
  box-shadow: 0px 0px 5px 3px rgba(0,0,0,0.2);
  border-radius: 8px;
  margin:20px;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`
export const BookInfoTitle = styled.h1`
  color: #1a1a1a;
  font-weight: 500;
  font-size: 28px;
  margin:0;
`
export const ColumnLeftBookInfoContent = styled.div`
  display:inline-block;
  width:15%;
  margin-top:10px;
`
export const ColumnRightBookInfoContent = styled.div`
  display:inline-block;
  margin-left:15px;
  margin-top:10px;
  width:80%
`
export const BookInfoImage = styled.img`
  width:100%;
  border-radius:8px;
`
export const BookInfoData = styled.h2`
  color: ${({ theme }) => theme.colors.fontSecondary};
  font-weight: 500;
  font-size: 23.5px;
  margin:0;
`
export const BookInfoDataCourtCol = styled.div`
  display:inline-block;
  margin:0;
  width:50%;
`
export const BookInfoDataPriceCol = styled.div`
  display:inline-block;
  margin:0;
  width:50%;
  text-align: right;
`
export const ReservationTotalContent = styled.div`
  height:67%;
  position:relative;
`
export const BookInfoTotalTitle = styled.h1`
  font-weight: 500;
  font-size: 37px;
  text-align:right;
  position:absolute;
  bottom:20px;
  right:20px;
`
export const BookInfoCardImage = styled.img`
 
`
export const PayButtonContent = styled.div`
    height:250px;
    position:relative;
`

export const CardFormContent = styled.div`
    padding-top: 35px;
`

export const RadioButtonLabel = styled.label`
  font-weight: 500;
  position: relative;
  cursor: pointer;
  font-size: 28px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  float: left;
  padding-right: 3px;
  display: flex; 
  align-items: center;
`

export const RadioButtonInput = styled.input`
  cursor: pointer;
  accent-color: ${({ theme }) => theme.colors.primary};
  width: 45px;
  height: 28px;
`